import { useEffect } from 'react'
import {
  BrowserRouter,
  Routes,
  useLocation,
  Navigate,
  Route,
} from 'react-router-dom'
import { GridLayout } from './layouts'
import { Aggregate } from '../pages'

const NavigationHelper = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
    })
  }, [pathname])

  return null
}

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <NavigationHelper />
      <Routes>
        <Route path="/" element={<GridLayout />}>
          <Route path="" element={<Navigate to="/aggregate" replace />} />
          <Route path="aggregate" element={<Aggregate />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
